import { TitleWidgetInterface, WidgetInterface } from "../../types";

interface Props {
    widget  : WidgetInterface;
    editable : boolean;
    onUpdate: (id: string, updates: Partial<WidgetInterface>) => void;
}

function defaultTitleWidgetInterface() : TitleWidgetInterface {
  return {type: 0}
}

export function TitleWidget(props : Props) {

const ts : TitleWidgetInterface = props.widget.data ? props.widget.data : defaultTitleWidgetInterface();
    
const changeMealType = () => {
        if (!props.editable)
            return
        
        props.onUpdate(props.widget.id, {
          data: {type:(ts.type+1) % 2}
        });
    }

const types_fi = ["Linjastojen ruuhkatilanne","Kartta"]
const types_en = ["Lunch line traffic status","Map"]

    return (
    <div style={{lineHeight: "2em"}}>
        <h2 onClick={changeMealType}>{types_fi[ts.type]}</h2>
        <h3 onClick={changeMealType}>{types_en[ts.type]}</h3>
    </div>
    )
}